import {
  CustomFormattedMessage,
  TranslationsKeys,
} from '../../../../i18n/i18n';

type ChapterSubHeadlineProps = {
  messageId: TranslationsKeys;
  textSize?: string;
};

export const ChapterSubHeadline = ({
  messageId,
  textSize = 'h4',
}: ChapterSubHeadlineProps) => (
  <div className={`col-xs-12 text-size-${textSize} margin-bottom-15`}>
    <CustomFormattedMessage id={messageId} />
  </div>
);
